module.exports = __webpack_public_path__ + "img/p2-5.abcf18b8.png";